document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  const root = document.documentElement;
  const densityToggle = document.querySelector('[data-density-toggle]');
  const desktopMedia = window.matchMedia('(min-width: 750px)');
  const mobileDensitySteps = ['compact', 'medium', 'single', 'medium'];
  const desktopDensitySteps = ['wide', 'focused'];
  let mobileDensityIndex = Number.parseInt(window.localStorage.getItem('avnt-browse-density-mobile') || '0', 10);
  let desktopDensityIndex = Number.parseInt(window.localStorage.getItem('avnt-browse-density-desktop') || '0', 10);

  if (Number.isNaN(mobileDensityIndex) || mobileDensityIndex < 0 || mobileDensityIndex >= mobileDensitySteps.length) {
    mobileDensityIndex = 0;
  }

  if (Number.isNaN(desktopDensityIndex) || desktopDensityIndex < 0 || desktopDensityIndex >= desktopDensitySteps.length) {
    desktopDensityIndex = 0;
  }

  const applyBrowseDensity = () => {
    root.dataset.browseDensityMobile = mobileDensitySteps[mobileDensityIndex];
    root.dataset.browseDensityDesktop = desktopDensitySteps[desktopDensityIndex];
  };

  const animateDensityTransition = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const cards = Array.from(document.querySelectorAll('.section-shell--browse-grid .product-card, .collection-shell--browse-grid .product-card'));
    const firstRects = new Map(cards.map((card) => [card, card.getBoundingClientRect()]));

    requestAnimationFrame(() => {
      cards.forEach((card) => {
        const firstRect = firstRects.get(card);
        const lastRect = card.getBoundingClientRect();

        if (!firstRect || !lastRect.width || !lastRect.height) {
          return;
        }

        const deltaX = firstRect.left - lastRect.left;
        const deltaY = firstRect.top - lastRect.top;
        const scaleX = firstRect.width / lastRect.width;
        const scaleY = firstRect.height / lastRect.height;

        card.style.transition = 'none';
        card.style.transformOrigin = 'center center';
        card.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`;

        requestAnimationFrame(() => {
          card.style.transition = 'transform 320ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms cubic-bezier(0.22, 1, 0.36, 1)';
          card.style.transform = '';
        });
      });

      window.setTimeout(() => {
        cards.forEach((card) => {
          card.style.removeProperty('transition');
          card.style.removeProperty('transform');
          card.style.removeProperty('transform-origin');
        });
      }, 340);
    });
  };

  applyBrowseDensity();

  if (densityToggle) {
    densityToggle.addEventListener('click', () => {
      if (desktopMedia.matches) {
        desktopDensityIndex = (desktopDensityIndex + 1) % desktopDensitySteps.length;
        window.localStorage.setItem('avnt-browse-density-desktop', String(desktopDensityIndex));
      } else {
        mobileDensityIndex = (mobileDensityIndex + 1) % mobileDensitySteps.length;
        window.localStorage.setItem('avnt-browse-density-mobile', String(mobileDensityIndex));
      }

      applyBrowseDensity();
      animateDensityTransition();
    });
  }

  const useSharedBrowseLayout = pathname === '/' || pathname === '/shop';

  if (useSharedBrowseLayout) {
    document.documentElement.classList.add('route-shop');
  }

  document.querySelectorAll('[data-path-scope]').forEach((node) => {
    const scope = (node.getAttribute('data-path-scope') || '').replace(/\/+$/, '') || '/';
    node.hidden = scope !== pathname;
  });

  if (useSharedBrowseLayout) {
    const mainContent = document.querySelector('#MainContent');

    if (mainContent) {
      const escapeHtml = (value) =>
        String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#39;');

      const formatMoney = (price) => {
        const amount = Number(price ?? 0);
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
        }).format(amount);
      };

      const renderCard = (product) => {
        const image = product.images && product.images.length ? product.images[0] : null;
        const soldOut = !(product.variants || []).some((variant) => variant.available);

        return `
          <a class="product-card" href="/products/${escapeHtml(product.handle)}">
            <div class="product-card__media">
              ${
                image
                  ? `<img src="${escapeHtml(`${image.src}&width=900`)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                  : ''
              }
            </div>
            <div class="product-card__body">
              <h3 class="product-card__title">${escapeHtml(product.title)}</h3>
              ${soldOut ? '<p class="product-card__badge">Sold Out</p>' : ''}
            </div>
          </a>
        `;
      };

      const renderSection = (title, anchorId, products) => `
        <section class="section-shell section-shell--minimal section-shell--browse-grid section-shell--plain-heading" id="${escapeHtml(anchorId)}">
          <div class="minimal-section-head is-visible" data-reveal>
            <h2 class="minimal-section-head__title">${escapeHtml(title)}</h2>
          </div>
          <div class="product-grid product-grid--minimal is-visible" data-reveal>
            ${
              products.length
                ? products.map(renderCard).join('')
                : '<div class="empty-state"><p class="section-copy">Products will appear here once they are published.</p></div>'
            }
          </div>
        </section>
      `;

      Promise.all([
        fetch('/collections/newarrivals/products.json?limit=250').then((response) => response.json()),
        fetch('/collections/vault/products.json?limit=250').then((response) => response.json()),
      ])
        .then(([newArrivalsPayload, vaultPayload]) => {
          const newArrivals = Array.isArray(newArrivalsPayload.products) ? newArrivalsPayload.products : [];
          const vault = Array.isArray(vaultPayload.products) ? vaultPayload.products : [];

          mainContent.innerHTML = `
            ${renderSection('NEW ARRIVALS', 'new-arrivals', newArrivals)}
            ${renderSection('VAULT', 'vault', vault)}
          `;
        })
        .catch(() => {
          /* Keep the existing markup in place if collection fetches fail. */
        });
    }
  }

  const navToggle = document.querySelector('[data-nav-toggle]');
  const navPanel = document.querySelector('[data-nav-panel]');

  if (navToggle && navPanel) {
    navToggle.addEventListener('click', () => {
      const expanded = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!expanded));
      navPanel.toggleAttribute('data-open');
    });

    navPanel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navToggle.setAttribute('aria-expanded', 'false');
        navPanel.removeAttribute('data-open');
      });
    });
  }

  const revealNodes = document.querySelectorAll('[data-reveal]');
  if (!revealNodes.length || !('IntersectionObserver' in window)) {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  revealNodes.forEach((node) => observer.observe(node));
});
